import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const pricniple: Slide = {
  descriptionHtml:
    "In this section, the results of a distance perception experiment with N participants are simulated. The simulated results are then statistically processed including the calculation of the mean, the standard deviation and are finally visulized as a box plot.<br><br>Two audio samples including sound sources at different distances were presented to the participants, who had to set the perceived distance using a continuous slider. When choosing a very low participant number, it can happen that H0 is not rejected, while for a larger participant count, the perceived distance or case A and B is different.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0225/`,
            },
          },
        },
      },
    },
  },
};

export default pricniple;
